var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndefinedTraceLabelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M7.99966 2.6667C8.27573 2.66678 8.49966 2.89061 8.49966 3.1667V7.4997H12.8327C13.1087 7.49985 13.3327 7.72365 13.3327 7.9997C13.3326 8.27572 13.1087 8.49956 12.8327 8.4997H8.49966V12.8327C8.49951 13.1087 8.27564 13.3326 7.99966 13.3327C7.72361 13.3327 7.49981 13.1087 7.49966 12.8327V8.4997H3.16666C2.89054 8.4997 2.6667 8.27581 2.66666 7.9997C2.66666 7.72356 2.89051 7.4997 3.16666 7.4997H7.49966V3.1667C7.49966 2.89055 7.72352 2.6667 7.99966 2.6667Z",
    fill: "#95999E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndefinedTraceLabelIcon);
export default __webpack_public_path__ + "static/media/undefined-trace-label-icon.0165bba41d4b1f549742b7a259a5f627.svg";
export { ForwardRef as ReactComponent };